import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["text", "button"]
    static values = {
        show: {type: String, default: "Show"},
        hide: {type: String, default: "Hide"}
    }

    toggle() {
        this.textTarget.classList.toggle("hidden")
        this._updateButtonText()
    }

    _updateButtonText() {
        const currentText = this.buttonTarget.textContent
        this.buttonTarget.textContent = currentText === this.hideValue ? this.showValue : this.hideValue
    }
}
